<template>
    <div class="form">
        <Form ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="90">
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="交易单号"
                    prop="transactionNumbers">
                    <Input v-model="info.transactionNumbers"
                        placeholder
                        :maxlength="50"
                        :disabled="loading"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="商品"
                    prop="commodity">
                    <Input v-model="info.commodity"
                        placeholder
                        :maxlength="50"
                        :disabled="loading"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="状态"
                    prop="payStatus">
                    <Select v-model="info.payStatus"
                        transfer
                        placeholder
                        :disabled="loading">
                        <Option v-for="(item, index) in payStatusList"
                            :value="item.id"
                            :key="index">{{item.text}}</Option>
                    </Select>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="支付时间"
                    prop="payTime">
                    <date-picker :disabled="loading"
                        style="width: 100%"
                        v-model="info.payTime"
                        transfer
                        type="datetime"></date-picker>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="支付金额"
                    prop="amount">
                    <input-number v-model="info.amount"
                        placeholder
                        :disabled="loading">
                        <span slot="append">元</span>
                    </input-number>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="支付方式"
                    prop="payType">
                    <Input v-model="info.payType"
                        placeholder
                        :disabled="loading"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="商户全称"
                    prop="businessName">
                    <Input v-model="info.businessName"
                        placeholder
                        :disabled="loading"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="商户单号"
                    prop="businessNumbers">
                    <Input v-model="info.businessNumbers"
                        placeholder
                        :disabled="loading"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="付款人姓名"
                    prop="payerName">
                    <Input v-model="info.payerName"
                        placeholder
                        :disabled="loading"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="付款人手机号"
                    prop="payerTel">
                    <Input v-model="info.payerTel"
                        placeholder
                        :disabled="loading"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="备注"
                    prop="remark">
                    <Input :disabled="loading"
                        v-model="info.remark"
                        placeholder
                        type="textarea"
                        :rows="2"
                        :maxlength="1000"></Input>
                </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { billAdd, billUpdate, billView } from '@/api/bill-info'
import Dict from '@/utils/dict'
import BaseImg from '@/components/base-img'
import dayjs from 'dayjs'
export default {
    name: 'BillForm',
    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },
    components: { BaseImg },
    inject: {
        $modal: {
            default: null
        }
    },
    data() {
        return {
            info: {
                id: '',
                transactionNumbers: '', //交易单号
                commodity: '', //商品
                amount: '', //支付金额
                payStatus: '', //支付状态
                payType: '', //支付方式
                payTime: '', //支付时间
                businessName: '', //商户名称
                businessNumbers: '', //商户单号
                payerName: '', //付款人姓名
                payerTel: '', //付款人手机号
                remark: '', //备注
                ver: '' //版本号
            },
            dict: {
                payStatus: Dict.NULL,
            },
            loading: false
        }
    },

    computed: {
        ruleValidate() {
            return {

            }
        },

        payStatusList() {
            return this.dict.payStatus.val()
        }
    },

    methods: {
        fetch() {
            if (this.id) {
                return billView(this.id)
            } else {
                return Promise.resolve()
            }
        }
    },

    mounted() {
        var $info = this.$refs.info
        this.loading = true
        // 预加载
        let body = {
            page: 1,
            pageSize: 999
        }
        this.$modal.beforeEnter(next => {
            Promise.all([Dict.get(['pay_status']), this.fetch()])
                .then(args => {
                    var [dictGroup, view] = args
                    Object.keys(this.dict).forEach(name => {
                        this.dict[name] = dictGroup[name] || Dict.NULL
                    })
                    if (view) {
                        var viewData = view.data
                        viewData.buyTime = viewData.buyTime ?
                            dayjs(viewData.buyTime).format(
                                'YYYY-MM-DD HH:mm:ss'
                            ) :
                            ''
                        viewData.payTime = viewData.payTime ?
                            dayjs(viewData.payTime).format(
                                'YYYY-MM-DD HH:mm:ss'
                            ) :
                            ''
                        Object.keys(this.info).forEach(
                            name => (this.info[name] = viewData[name])
                        )
                    }
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)
                    formData.buyTime = formData.buyTime ?
                        dayjs(formData.buyTime).format('YYYY-MM-DD HH:mm:ss') :
                        ''
                    formData.payTime = formData.payTime ?
                        dayjs(formData.payTime).format('YYYY-MM-DD HH:mm:ss') :
                        ''
                    if (this.id) {
                        return billUpdate(formData)
                    } else {
                        return billAdd(formData)
                    }
                })
                .then(res => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch(err => (options.closeModal = false))
                .finally(() => next())
        })
    }
}
</script>
<style lang="less"
    scoped>
</style>